import { render } from "./resourcesView.vue?vue&type=template&id=4e3e2566"
import script from "./resourcesView.vue?vue&type=script&lang=js"
export * from "./resourcesView.vue?vue&type=script&lang=js"

import "./resourcesView.vue?vue&type=style&index=0&id=4e3e2566&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__